import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AdasInfoSheetComponent,
  OperationTypeInfoSheetComponent,
  WeatherInfoSheetComponent,
} from '@sc/ui-components';
import { RouterInfoActionTypes } from '@sc/data-access-models';

@Component({
  selector: 'sc-router-info-action-dialog',
  styleUrls: ['./router-info-action-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    OperationTypeInfoSheetComponent,
    AdasInfoSheetComponent,
    WeatherInfoSheetComponent,
  ],
  template: `
    <sc-operation-type-info-sheet
      *ngIf="data?.dialogType === 'operation-type-infos'"
      (closeEvent)="onCloseSheet()"
      [dossier]="data?.dossier"
    ></sc-operation-type-info-sheet>
    <sc-adas-info-sheet
      *ngIf="data?.dialogType === 'adas-infos'"
      (closeEvent)="onCloseSheet()"
      [dossier]="data?.dossier"
    ></sc-adas-info-sheet>
    <sc-weather-info-sheet
      *ngIf="data?.dialogType === 'weather-infos'"
      (closeEvent)="onCloseSheet()"
    ></sc-weather-info-sheet>
  `,
})
export class RouterInfoActionDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RouterInfoActionTypes,
    private readonly dialogRef: MatDialogRef<
      RouterInfoActionDialogComponent,
      RouterInfoActionTypes
    >
  ) {}

  onCloseSheet() {
    this.dialogRef.close();
  }
}
